"use client";

import { CustomSlider } from "@/components/ui/custom-slider";

interface DynamicAreaSectionProps {
	value: number;
	onChange: (value: number) => void;
}

const areaSteps = [1000, 2000, 3000, 4000, 5000, 6000, 7000];

export function DynamicAreaSection({ value, onChange }: DynamicAreaSectionProps) {
	// Find the index of the closest step to the current value
	const findClosestIndex = (val: number) => {
		let closest = 0;
		let minDiff = Infinity;
		areaSteps.forEach((step, idx) => {
			const diff = Math.abs(step - val);
			if (diff < minDiff) {
				minDiff = diff;
				closest = idx;
			}
		});
		return closest;
	};

	const currentSliderIndex = findClosestIndex(value);

	// Keep slider and input in sync
	const handleSliderChange = (newIndex: number) => {
		onChange(areaSteps[newIndex]);
	};

	return (
		<div className="space-y-6">
			<div className="space-y-4">
				<div className="relative h-6 flex items-center px-3">
					<CustomSlider
						value={currentSliderIndex}
						onChange={newIndex => handleSliderChange(newIndex as number)}
						min={0}
						max={areaSteps.length - 1}
						step={1}
						ariaLabel="Minimum Area"
						rangeClassName="absolute bg-gray-600 rounded-full h-full"
					/>
				</div>
				<div className="flex justify-between text-xs text-gray-600 select-none pointer-events-none mb-2 px-3">
					{areaSteps.map((step, idx) => {
						const isSelected = idx === currentSliderIndex;
						return (
							<div
								key={step}
								className="flex flex-col items-center gap-1"
								style={{
									minWidth: 36,
									paddingLeft: idx === 0 ? 0 : 0,
									paddingRight: idx === areaSteps.length - 1 ? 2 : 0,
								}}
							>
								<div className={`w-px h-2 ${isSelected ? "bg-primary-600" : "bg-gray-400"}`} />
								<span
									className={`text-xs font-semibold ${isSelected ? "text-primary-600" : "text-gray-600"}`}
									style={{ padding: "0 2px" }}
								>
									{step}+
								</span>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
